(function ($) {
    class W4D_Instashop {
        constructor() {
            this.bindEvents();
        }

        bindEvents() {
            $(document).on('click', '.instashop-2__marker', (e) => {
                e.stopPropagation();
                const $marker = $(e.currentTarget);
                const targetSel = $marker.data('popup-target');
                const $popup = $(targetSel);
                this.positionAndShowPopup($marker, $popup);
            });

            $(document).on('click', '.js-instashop-popup-close', (e) => {
                e.stopPropagation();
                $(e.currentTarget).closest('.instashop-2__popup').fadeOut(100);
            });

            $(document).on('click', function () {
                $('.instashop-2__popup').fadeOut(100);
            });

            $(document).on('click', '.instashop-2__popup', (e) => {
                e.stopPropagation();
            });

            $(document).on('click', '.js-instashop-open-overlay', () => {
                $('body').addClass('instashop-mobile-overlay-active');
                $('.instashop-2__mobile-overlay').fadeIn(150);
            });

            $(document).on('click', '.js-instashop-close-overlay', () => {
                $('.instashop-2__mobile-overlay').fadeOut(150);
                $('body').removeClass('instashop-mobile-overlay-active');
            });

            $(document).on('click', '.instashop-2__mobile-overlay', (e) => {
                if ($(e.target).is('.instashop-2__mobile-overlay')) {
                    $('.instashop-2__mobile-overlay').fadeOut(150);
                    $('body').removeClass('instashop-mobile-overlay-active');
                }
            });
        }

        positionAndShowPopup($marker, $popup) {
            $('.instashop-2__popup').hide();
            const markerPos = $marker.position();
            const markerW = $marker.outerWidth();
            const markerH = $marker.outerHeight();

            $popup.css({
                display: 'block',
                visibility: 'hidden'
            });
            const popupW = $popup.outerWidth();
            const popupH = $popup.outerHeight();

            const $container = $marker.closest('.instashop-2__image');
            const contW = $container.innerWidth();
            const contH = $container.innerHeight();

            let topValue = markerPos.top + (markerH / 2) - (popupH / 2);
            if (topValue < 10) {
                topValue = 10;
            }
            if (topValue + popupH > contH - 10) {
                topValue = contH - popupH - 10;
            }

            const spaceRight = contW - (markerPos.left + markerW);
            let leftValue, positionClass;
            if (spaceRight < popupW + 10) {
                leftValue = markerPos.left - popupW - 10;
                positionClass = 'popup--left';
            } else {
                leftValue = markerPos.left + markerW + 10;
                positionClass = 'popup--right';
            }

            $popup
                .css({
                    top: topValue,
                    left: leftValue,
                    visibility: 'visible'
                })
                .removeClass('popup--left popup--right')
                .addClass(positionClass)
                .fadeIn(150);
        }
    }

    $(document).ready(function () {
        window.W4D_Instashop = new W4D_Instashop();
    });
})(jQuery);
